import Popup from 'components/popup';
import Slider from 'components/slider/index';

// Большой слайдер
let slider = {};
const sliderWrap = document.querySelector('.j-first-screen-slider');

if (sliderWrap) {
    slider = new Slider();

    slider.init({
        slider       : sliderWrap,
        dots         : false,
        thumbnails   : false,
        arrow        : false,
        counter      : false,
        arrowPosition: 'caption',
        caption      : false,
        noSwipe      : true,
        autoplay     : true,
        autoplaySpeed: 5000,
        infinityLoop : true
    });
}

// Подключение попапа с панорамой
const popupPlanoplanLinks = Array.from(document.querySelectorAll('.j-popup-planoplan-walk'));

if (popupPlanoplanLinks.length) {
    const popupOptions = {
        openButtons         : popupPlanoplanLinks,
        closeButtonAriaLabel: 'Закрыть 3D тур',
        template            : 'marginless'
    };

    const popupPlanoplan = new Popup(popupOptions);

    popupPlanoplan.init();
}
